import React from "react";
import DropdownMenu, { ActionsProps } from "../../Inputs/DropdownMenu";
import { Button } from "../Buttons/Button";

const DropdownButton: DropdownMenu["customButton"] = ({
  onPress,
  disabled,
}) => {
  return (
    <Button
      variant="outlineInverted"
      title="Actions"
      onPress={onPress}
      isDisabled={disabled}
      size="small"
    />
  );
};

type CarouselModalActionButtonProps = {
  actions: ActionsProps[];
};

export function CarouselModalActionButton({
  actions,
}: CarouselModalActionButtonProps) {
  if (actions.length === 0) {
    return null;
  }

  return (
    <DropdownMenu
      buttonText="Actions"
      actions={actions}
      customButton={DropdownButton}
    />
  );
}
